import React, { useState } from "react";
import { Header } from "../components/sections/Header";
import { Footer } from "../components/sections/Footer";
import { CookieBanner } from "../components/ui/CookieBanner";
import { FriendsSection } from "../components/sections/FriendsSection";
import { RecapSection } from "../components/sections/RecapSection";
import { HeroSection } from "../components/sections/HeroSection";
import { LocationSection } from "../components/sections/LocationSection";
import { MerchSection } from "../components/sections/MerchSection";
import { PartnersSection } from "../components/sections/PartnersSection";
import { ProgramSection } from "../components/sections/ProgramSection";
import { SpeakersSection } from "../components/sections/SpeakersSection";
import { TracksSection } from "../components/sections/TracksSection";
import { navItems } from "../config/site";
import { type TrackTab } from "../content/site";
import { useActiveSection } from "../hooks/useActiveSection";
import { scrollToId } from "../utils/dom";

type Props = {
    initialSpeakerTab?: TrackTab;
    initialProgramTab?: TrackTab;
};

export default function App({
    initialSpeakerTab = "Войти в IT",
    initialProgramTab = "Войти в IT",
}: Props) {
    const [speakerTab, setSpeakerTab] = useState<TrackTab>(initialSpeakerTab);
    const [programTab, setProgramTab] = useState<TrackTab>(initialProgramTab);
    const activeSection = useActiveSection(navItems);

    return (
        <div className="relative min-h-screen overflow-x-clip">
            <div
                className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
                aria-hidden="true"
            >
                <div
                    className="absolute md:hidden rounded-full bg-[#96EA28]"
                    style={{
                        width: "405.58px",
                        height: "191.8px",
                        top: "-120px",
                        left: "-220px",
                        transform: "rotate(6.68deg)",
                        opacity: 1,
                        filter: "blur(58.8px)",
                    }}
                />
                <div
                    className="hidden md:block absolute rounded-full bg-[#96EA28]"
                    style={{
                        width: "760px",
                        height: "480px",
                        top: "-200px",
                        left: "-400px",
                        transform: "rotate(6.68deg)",
                        filter: "blur(220px)",
                    }}
                />
                <div
                    className="absolute rounded-full bg-[#96EA28] md:hidden"
                    style={{
                        width: "405.58px",
                        height: "191.8px",
                        right: "-180px",
                        bottom: "-110px",
                        transform: "rotate(0.06deg)",
                        opacity: 1,
                        filter: "blur(98.8px)",
                    }}
                />
                <div
                    className="hidden md:block absolute rounded-full bg-[#96EA28]"
                    style={{
                        width: "1120px",
                        height: "460px",
                        right: "-560px",
                        bottom: "-300px",
                        transform: "rotate(0.06deg)",
                        filter: "blur(260px)",
                    }}
                />
            </div>
            <Header activeSection={activeSection} onNavigate={scrollToId} />
            <main id="top" className="relative overflow-x-clip">
                <HeroSection />
                <RecapSection />
                <div className="relative z-10">
                    <p className="mx-auto mt-20 max-w-[1400px] px-4 text-sm uppercase tracking-[0.12em] text-accent sm:px-6">
                        Материалы конференции · 18 апреля 2026
                    </p>
                    <ProgramSection activeTab={programTab} onChange={setProgramTab} />
                    <TracksSection onTrackSelect={setSpeakerTab} onNavigate={scrollToId} />
                    <SpeakersSection activeTab={speakerTab} onChange={setSpeakerTab} />
                    <PartnersSection />
                    <MerchSection />
                    <LocationSection />
                    <FriendsSection />
                </div>
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
}
